<template>
  <section>
    <div class="container text-center">
      <h2>We Welcome All Media Inquiries</h2>
      <p><strong>Please Contact:</strong><br>
        Tamara Lover, Trustee Board President, Pencils For Kids UK</p>
      <p>Email: Tamara@pencilsforkidsuk.co.uk</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'media-inquiries'
}
</script>

<style lang="scss" scoped>
  @import '~assets/styles/vars';

  section {
    background: $ltBrown;
    color: $white;
    padding: 80px 0;
  }

  p {
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// MediaInquiries.vue?a3dcc2d4